import { useCallback, useRef, useState } from 'react';

const DEFAULT_INITIAL_HEIGHT = 240;
const DEFAULT_VERTICAL_MARGIN = 12;
const DEFAULT_MIN_HEIGHT = 120;

export const useAutocompleteDropdownHeight = ({
  initialHeight = DEFAULT_INITIAL_HEIGHT,
  verticalMargin = DEFAULT_VERTICAL_MARGIN,
  minHeight = DEFAULT_MIN_HEIGHT,
  ancestorSelector = '.table-panel-container',
} = {}) => {
  const containerRef = useRef(null);
  const [availableHeight, setAvailableHeight] = useState(initialHeight);

  const updateAvailableHeight = useCallback(() => {
    if (!containerRef.current) {
      return;
    }

    const rect = containerRef.current.getBoundingClientRect();
    const viewportSpace = typeof window !== 'undefined'
      ? window.innerHeight - rect.bottom - verticalMargin
      : initialHeight;

    const ancestor = ancestorSelector
      ? containerRef.current.closest(ancestorSelector)
      : null;

    const constrainedSpace = ancestor
      ? Math.min(ancestor.getBoundingClientRect().bottom - rect.bottom - verticalMargin, viewportSpace)
      : viewportSpace;

    setAvailableHeight(Math.max(minHeight, constrainedSpace));
  }, [ancestorSelector, initialHeight, minHeight, verticalMargin]);

  return {
    containerRef,
    availableHeight,
    updateAvailableHeight,
  };
};

export default useAutocompleteDropdownHeight;